const ReactRailsUJS = require("react_ujs");
const componentRequireContext = require.context("login", true, /^((?!test).)*$/);
ReactRailsUJS.useContext(componentRequireContext);
